"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ruleKeys = exports.commonRuleKeys = void 0;
exports.commonRuleKeys = ["active", "unit", "rotationUnit", "layer"];
exports.ruleKeys = [
    ...exports.commonRuleKeys,
    "gridSpacing",
    "zIsUp",
    "position",
    "positionX",
    "positionY",
    "positionZ",
    "startPosition",
    "startPositionX",
    "startPositionY",
    "startPositionZ",
    "endPosition",
    "endPositionX",
    "endPositionY",
    "endPositionZ",
    "rotation",
    "rotationX",
    "rotationY",
    "rotationZ",
    "size",
    "sizeX",
    "sizeY",
    "sizeZ",
    "minSize",
    "minSizeX",
    "minSizeY",
    "minSizeZ",
    "maxSize",
    "maxSizeX",
    "maxSizeY",
    "maxSizeZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "keepOut",
    "minKeepOut",
    "maxKeepOut",
    "keepIn",
    "minKeepIn",
    "maxKeepIn",
    "boardInsetMargin",
    "autoLayoutGravity",
    "cornerRadius",
    "minCornerRadius",
    "maxCornerRadius",
    "cornerRadiusTopLeft",
    "minCornerRadiusTopLeft",
    "maxCornerRadiusTopLeft",
    "cornerRadiusTopRight",
    "minCornerRadiusTopRight",
    "maxCornerRadiusTopRight",
    "cornerRadiusBottomRight",
    "minCornerRadiusBottomRight",
    "maxCornerRadiusBottomRight",
    "cornerRadiusBottomLeft",
    "minCornerRadiusBottomLeft",
    "maxCornerRadiusBottomLeft",
    "zoneShape",
    "polygonShape",
    "padShape",
    "padHoleType",
    "viaType",
    "viaOptions",
    "thermalRelief",
    "thermalReliefConductors",
    "thermalReliefConductorWidth",
    "thermalReliefConductorAngle",
    "solderPasteMaskExpansion",
    "solderMaskExpansion",
    "solderMaskTopExpansion",
    "solderMaskBottomExpansion",
    "solderMaskExpansionFromTheHoleEdge",
    "holeSize",
    "holeSizeX",
    "holeSizeY",
    "minHoleSize",
    "minHoleSizeX",
    "minHoleSizeY",
    "maxHoleSize",
    "maxHoleSizeX",
    "maxHoleSizeY",
    "holePosition",
    "holePositionX",
    "holePositionY",
    "boardColor",
    "boardShape",
    "silkColor",
    "asset",
    "physicalMaterials",
    "showEdges",
    "stackup",
    "content",
    "fontSize",
    "minFontSize",
    "maxFontSize",
    "fontStyle",
    "textAlign",
    "traceWidth",
    "minTraceWidth",
    "maxTraceWidth",
    "strokeWidth",
    "minStrokeWidth",
    "maxStrokeWidth",
    "strokeStyle",
    "strokeLength",
    "strokeSpacing",
    "connectedLayers",
    "linePath",
    "traceShape",
    "traceShapeStart",
    "traceShapeEnd",
    "traceCornerRadius",
    "traceCornerRadiusStart",
    "traceCornerRadiusEnd",
    "traceCornerRadiusMinimum",
    "preferredTraceWidths",
    "fillStitchingDensity",
    "fillStitchingOffset",
    "package",
    "gridArrayCount",
    "gridArrayCountX",
    "gridArrayCountY",
    "gridArrayRowAlphabet",
    "gridArrayColumnAlphabet",
    "ballType",
    "pinPitch",
    "pinPitchX",
    "pinPitchY",
    "pinSize",
    "pinSizeX",
    "pinSizeY",
    "pinSizeZ",
    "packageSize",
    "packageSizeX",
    "packageSizeY",
    "packageSizeZ",
    "packagePlacementTolerance",
    "packagePlacementToleranceX",
    "packagePlacementToleranceY",
    "packageFabricationTolerance",
    "packageFabricationToleranceX",
    "packageFabricationToleranceY",
    "packageFabricationToleranceZ",
    "mapSilkscreenToBody",
    "padOuterMargin",
    "thermalPadSize",
    "thermalPadSizeX",
    "thermalPadSizeY",
    "autoLayoutPriority",
    "protected",
];
//# sourceMappingURL=structure.js.map